import { render, staticRenderFns } from "./AddFeedbackTicketCommentsDialog.vue?vue&type=template&id=7538e031&"
import script from "./AddFeedbackTicketCommentsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddFeedbackTicketCommentsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports